module.exports = __webpack_public_path__ + "static/media/image-card-3.9a6a21e7.png";